import React from 'react';
import { IData } from '../virtual-data/VirtualData';
import { FinalTableComputedColumn, FinalTableProps } from './FinalTableProps';
import { GridCellProps } from 'react-virtualized/dist/es/Grid';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { Deleted } from '../deleted/Deleted';
import { Skeleton } from '../skeleton/Skeleton';
import { getFormattedValue, supportsAggregate } from './utils';
import { ColumnAggregate } from './ColumnAggregate';

type Props<DATA extends IData<ID>, FILTER, ID> = {
  finalTableProps: FinalTableProps<DATA, FILTER, ID>;
  column: FinalTableComputedColumn<DATA>;
  gridCellProps: GridCellProps;
  isHovered?: boolean;
  setIsHover?: (isHovered: boolean) => void;
};

export const FooterCell = <DATA extends IData<ID>, FILTER, ID>({
  finalTableProps,
  gridCellProps,
  column,
  isHovered,
  setIsHover,
}: Props<DATA, FILTER, ID>) => {
  const rowData = finalTableProps.getFooter();

  // Aggregate sloupec
  const field = column.accessor;
  let aggregate = field ? finalTableProps.getAggregate(field) : undefined;

  const isAggregateCol = !!aggregate;

  const cellClassName = classNames(
    column.className,
    Classes.FINAL_TABLE_FOOTER_CELL,
    {
      [Classes.FINAL_TABLE_BODY_CHECK_CELL]:
        finalTableProps.config.checkable && column.check,
      [Classes.FINAL_TABLE_BODY_ACTION_CELL]: column.type === 'action',
    }
  );

  let cellContent = undefined;
  if (finalTableProps.config.checkable && column.check && column?.cell) {
  } else {
    if (rowData === null) {
      // Ze serveru nebyla vrácena data - záznam byl smazán - zobrazíme jako "deleted"
      cellContent = (
        <div className={Classes.FINAL_TABLE_BODY_CELL_VALUE}>
          <Deleted />
        </div>
      );
    } else if (rowData === undefined) {
      // Záznam ještě nebyl ze serveru načten - zobrazujeme jako loading
      cellContent = (
        <div className={classNames(Classes.FINAL_TABLE_BODY_CELL_VALUE)}>
          {isAggregateCol && (
            <Skeleton
              row={gridCellProps.rowIndex}
              col={gridCellProps.columnIndex}
            />
          )}
          <ColumnAggregate
            column={column}
            finalTableProps={finalTableProps}
            isHovered={isHovered}
            setIsHover={setIsHover}
          />
        </div>
      );
    } else {
      // @ts-ignore
      let cellValue = aggregate ? rowData?.aggregate[field] : undefined;
      cellContent = (
        <div className={classNames(Classes.FINAL_TABLE_BODY_CELL_VALUE)}>
          <ColumnAggregate
            column={column}
            finalTableProps={finalTableProps}
            isHovered={isHovered}
          />
          {supportsAggregate(column.type) && column.aggregatedCell
            ? column.aggregatedCell({
                rowIndex: -1,
                columnIndex: gridCellProps.columnIndex,
                row: rowData,
                column,
                value: cellValue,
                formattedValue: column.aggregatedType
                  ? getFormattedValue(column, true, cellValue)
                  : undefined,
              })
            : cellValue}
        </div>
      );
    }
  }

  return (
    <div
      key={gridCellProps.key}
      className={cellClassName}
      style={gridCellProps.style}
    >
      {cellContent}
    </div>
  );
};
